<template>
  <Error500 ref="error500"></Error500>
</template>

<script>
  import Error500 from "./Error500.vue";

  export default {
    name: "Error500Wrapper",
    components: {
      Error500,
    },
  };
</script>
